export const MobileListingDrawerZIndex = {
  ListingGroupDetails: 190, // Listing Group comes beneath listing details
  ListingDetails: 200, // Listing details root drawer, as base
  ListingPriceInput: 210, // Listing price input drawer
  ListingActions: 210, // Listing actions drawer
  ListingSectionalView: 220, // Listing price sectional view drawer
};
